import React from 'react';

const EventsPage: React.FC = () => {
  return (
    <div style={{ padding: '50px', textAlign: 'center' }}>
      <h1>이벤트 페이지</h1>
      <p>웹사이트 내에서 이벤트를 진행하는 페이지입니다.</p>
      <p>추후 구현 예정입니다.</p>
    </div>
  );
};

export default EventsPage;